import { Link } from "gatsby";
import React from "react";

const Appraise = () => {
  const data = [
    {
      text:
        "我们很早就开始推行HR系统，在使用过程中，国内市场上的人力资源信息化产品确实令我们有些失望。过去的两年里随着华夏航空的迅猛发展，公司人力部门的业务模式也发生了翻天覆地的变革，批量招聘的多环节业务无法在系统里实现，面试现场的秩序混乱，面试资料频繁丢失问题凸显。正是在这个关键时刻，大任软件凭借其专业的技术实力，成功解决了我们行业长期以来面临的批量招聘难题。大任软件推动了公司人力部门业务模式的升级，为华夏航空的迅猛发展注入了强劲动力。对大任软件的专业服务，我深感赞赏！",
      author: "华夏航空人力资源项目经理 赵泽华",
      link: "/trend/chinaexpressair",
    },
    {
      text:
        "我们这种中型金融公司，一直都面临人员流动频繁、招聘多，群面多的人事问题。随着业务版图的拓展，为应高频次的招聘，在每个工作室都配置了专职的HR人员。随着HR团队的壮大，信息隔阂问题却日益凸显。信息重复录入、人员重复面试，打卡记录混乱等问题凸显。幸运的是，我们引入了大任软件，这一明智之举彻底改变了我们的困境。该软件实现了信息的全面共享，使得招聘工作变得高效且有针对性，避免了无谓的重复劳动。此外，人事档案管理也变得井井有条，极大提升了我们的管理效率。我们与大任软件已合作长达七年之久，期间软件运行稳定，性能卓越，为我们企业的稳健运营提供了坚实的技术支撑。",
      author: "锦程消费金融HR经理 任紫璇",
      link: "/trend/jincheng",
    },
    {
      text:
        "繁琐的纸质人事档案管理让我们疲于应对，信息的模糊与低效更是拖慢了我们的步伐。大任HR系统的出现，彻底改变了这一局面。它实现了人事档案的全面数据化，让所有的流程都能在线轻松办理，更为我们统一梳理并规范了各项人事业务。以往，专业的HR系统常常需要高昂的投入，动辄百万，这让许多中小企业望而却步。但大任HR系统为我们打开了一扇新的大门，它以合理的价格，让中小企业也能轻松实现人力资源的信息化管理，这无疑是一场管理模式的革新。",
      author: "中移物联网人力系统负责人 张泽东",
      link: "/trend/zywlw",
    },
  ];
  return (
    <section className="featured-services-area pt-70 pb-70 bg-light">
      <div className="container">
        <div className="section-title mb-4 pb-2">
          <h2 className="title mb-2">大任HR系统已经管理超过600,000+员工</h2>
          <p className="ma">专业的人力资源管理平台，让HR的工作变得如此简单。</p>
        </div>
        <div className="row">
          {data.map((item, key) => (
            <div className="col-lg-4 col-sm-6" key={key}>
              <Link to={item.link}>
                <div className="single-services-item-box px-2">
                  <div className="single-testimonials-item px-2">
                    <p className="text-left" style={{ fontSize: 14 }}>
                      {item.text}
                    </p>

                    <div className="client-info">
                      <div className="d-flex justify-content-center align-items-center">
                        <div className="title">
                          <span>- {item.author}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Appraise;
